// SemanticUI-free pre-@plone/components
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';
import { UniversalLink } from '@plone/volto/components';
import { toBackendLang } from '@plone/volto/helpers';
import baseMessages from '@fhnw/messages/base';
import { useSelector } from 'react-redux';

const messages = defineMessages({
  logoLinkTitle: {
    id: 'Back to home page',
    defaultMessage: 'Back to home page',
  },
  logoAltText: {
    id: 'Logo of the University of Applied Sciences and Arts Northwestern Switzerland',
    defaultMessage:
      'Logo of the University of Applied Sciences and Arts Northwestern Switzerland',
  },
});

const Logo: React.FC = () => {
  const { settings } = config;
  const intl = useIntl();
  const currentLocation = useSelector(
    (state: any) => state.router?.location?.pathname,
  );
  const homePath = settings?.isMultilingual
    ? `/${toBackendLang(intl.locale)}`
    : '/';

  const handleClick = (e: React.MouseEvent) => {
    if (currentLocation === homePath) {
      e.preventDefault();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.key === 'Enter' || e.key === ' ') && currentLocation === homePath) {
      e.preventDefault();
    }
  };

  // Logo SVG intrinsic dimensions: DE=217×50, EN=349×50.
  // Providing width/height lets the browser reserve the correct aspect ratio
  // before the image loads, avoiding CLS from the logo expanding from 0-width.
  const isDe = intl.locale === 'de';
  const logoSrc = `/logo/fhnw-logo-${isDe ? 'de' : 'en'}.svg`;
  const logoWidth = isDe ? 217 : 349;
  const logoHeight = 50;

  return (
    <UniversalLink
      href={homePath}
      // @ts-ignore
      title={intl.formatMessage(messages.logoLinkTitle)}
      openLinkInNewTab={false}
      // @ts-ignore
      className="logo-container"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <picture title={intl.formatMessage(baseMessages.fhnwTitle)}>
        <img
          src={logoSrc}
          alt={intl.formatMessage(messages.logoAltText)}
          title={intl.formatMessage(baseMessages.fhnwTitle)}
          width={logoWidth}
          height={logoHeight}
        />
      </picture>
    </UniversalLink>
  );
};

export default Logo;
